// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { Children, cloneElement, isValidElement, ReactNode } from 'react';

export type SectionContentProviderProps<T> = {
    get(): Promise<Array<T>>;
    type: string;
    children: ReactNode;
};

export function SectionContentProvider<T>(props: SectionContentProviderProps<T>): JSX.Element {
    const { status, data } = useQuery([props.type], props.get);
    // call for data and store in contentdata
    const contentData: Array<T> = data;
    const errorStatusElement = <div> Error! </div>;
    const loadingStatusElement = <div>Loading...</div>;
    const updateChildrenWithProps = () =>
        Children.map(props.children, child => {
            if (isValidElement(child)) {
                return contentData.map((item: T) =>
                    cloneElement<ReactNode>(child, {
                        //this properties are available as a props in child components
                        ...item,
                    })
                );
            }
        });

    function renderDataStatus(status: string) {
        switch (status) {
            case 'loading':
                return loadingStatusElement;
            case 'error':
                return errorStatusElement;
            default:
                return updateChildrenWithProps();
        }
    }

    return <>{renderDataStatus(status)}</>;
}
